import { EmptyState, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledEmptyState = styled(EmptyState) `
  padding-left: ${theme.spacing.xl};
  padding-right: ${theme.spacing.xl};
`;
